<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import Title from '$shared/atoms/Title/Title.svelte';
  import type { CaqhMergeListOption } from '$shared/components/types';

  interface Props {
    option: CaqhMergeListOption;
  }

  let { option }: Props = $props();

  let hasIcon = $derived(option?.icon);
  let hasDesc = $derived(option?.description);
</script>

<div class="header-container">
  <div data-cy="header-title" class="header-label">
    <div class="icon" class:show={hasIcon}>
      <Icon value={option?.icon} fontSize="24px" size="24px" />
    </div>
    <Title type="h2">{option?.title || 'Unknown Title'}</Title>
  </div>
  <div data-cy="header-description" class="description" class:show={hasDesc}>
    {option?.description}
  </div>
</div>

<style>
  .header-container {
    padding: 8px 0px 12px;
  }
  .header-label {
    display: flex;
  }
  .header-label .icon {
    display: none;
  }
  .header-label .icon.show {
    margin-right: 8px;
    display: flex;
    align-items: center;
    display: block;
  }
  .description {
    display: none;
  }
  .description.show {
    display: block;
    margin-top: 8px;
    line-height: 22px;
  }
</style>
